import React from "react";

const AlterarDadosPessoais = (props) => {
  return (
    <div className="col-md-12 bg-white rounded-4 p-3">
      <h4 className="mt-4 mb-5 me-1 ms-1">Informação pessoal</h4>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Nome completo
        </div>
        <div className="col-8 text-end">
          {props.userData.name}
        </div>
        {/* <div className="col-4 text-end">
          
        </div> */}
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          NIF
        </div>
        <div className="col-8 text-end">
          {props.userData.nif}
        </div>
        {/* <div className="col-4 text-end">
          
        </div> */}
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          E-mail
        </div>
        <div className="col-8 text-end">
          {props.userData.email}
        </div>
        {/* <div className="col-4 text-end">
          <button
              type="button" className="btn btn-secondary" style={{padding:'5px 10px', fontSize:'11px'}}
              onClick={() => editEmail()}
            >
              Editar
          </button>
        </div> */}
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Data de Nascimento
        </div>
        <div className="col-8 text-end">
          {/*changeDateSeparatorToBar(props.userData.bornDate)*/}
          {props.userData.bornDate}
        </div>
        {/* <div className="col-4 text-end">

        </div> */}
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Morada
        </div>
        <div className="col-8 text-end">
          {props.userData.address}
        </div>
        {/* <div className="col-4 text-end">

        </div> */}
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Localidade
        </div>
        <div className="col-8 text-end">
          {props.userData.location}
        </div>
        {/* <div className="col-4 text-end">   
        </div> */}
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          País
        </div>
        <div className="col-8 text-end">
          {props.userData.country}
        </div>
        {/* <div className="col-4 text-end">
          
        </div> */}
      </div>
      {props.userData.companyName && (
      <div>
      <h4 className="mt-5 mb-5 me-1 ms-1">Dados da empresa</h4>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Nome da empresa
        </div>
        <div className="col-8 text-end">
          {props.userData.companyName}
        </div>
        {/* <div className="col-4 text-end">
          
        </div> */}
      </div>
      </div>
      )}
      {/* <h4 className="mt-5 mb-5 me-1 ms-1">Documentos</h4>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Documentos de identificação
        </div>
        <div className="col-4 text-end">
          15-11-2022
        </div>
        <div className="col-4 text-end">
          
        </div>
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Comprovativo de morada
        </div>
        <div className="col-4 text-end">
          15-11-2022
        </div>
        <div className="col-4 text-end">

        </div>
      </div> */}
    </div>
  );
};

export default AlterarDadosPessoais;
